/**
 * The organisation's Roads map tile address (N19, decision 641; `roadsTiles` in @teslyn/domain), set from the tenant
 * row when it is read (`applyThemeAndTitle`) and used by every map's Roads base layer (`baseLayer` in leaflet.ts).
 * Signed out, or not set: OpenStreetMap's own tiles. Kept apart from leaflet.ts so the start-up code loads no map.
 */
import { ROADS_TILES_DEFAULT, type RoadsTiles } from '@teslyn/domain';

let roads: RoadsTiles = ROADS_TILES_DEFAULT;

export function setRoadsTiles(r: RoadsTiles): void {
  roads = r;
}

export function currentRoadsTiles(): RoadsTiles {
  return roads;
}
